<template>
  <div id="root" class="root">
    <router-view></router-view>
  </div>
</template>

<script>

export default {

};
</script>

<style lang="scss">
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  box-sizing: border-box;
  @media (min-width: 768px) {
    width: 100%;
  }
  @media (min-width: 992px) {
    width: 100%;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
}
</style>
